<template>
    <div class="content-wapper">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item>人才对接</el-breadcrumb-item>
                </el-breadcrumb>
                <!--
                <span>当前位置: &nbsp;&nbsp;</span>
                <span>小微企业成长服务 </span>
                <span>&nbsp; &gt; &nbsp;</span>
                <el-link :underline="false" @click="refresh" class="router"> 人才对接</el-link>
                -->
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="6" style="height: 100%;">
                <el-row class="left-img">
                    <img src="@/assets/images/xwqyczfw/rcdj/1.png"/>
                </el-row>
                <el-row class="menu-box" style="height: 340px;">
                    <el-menu default-active="2"
                             class="el-menu-vertical-demo"
                             text-color="#000"
                             active-text-color="#ffd04b"
                             @select="handleSelect">
                        <el-menu-item index="2">
                            <i class="el-icon-link"></i>
                            <span slot="title">毕业生生源信息</span>
                        </el-menu-item>
                        <el-menu-item index="1">
                            <i class="el-icon-link"></i>
                            <span slot="title">企业招聘信息</span>
                        </el-menu-item>
						<el-menu-item index="3">
						    <i class="el-icon-link"></i>
						    <span slot="title" @click="openNewPage">威海市就业服务平台</span>
						</el-menu-item>
                    </el-menu>
                </el-row>
            </el-col>

            <el-col :span="18" class="right-box" v-if="topTableView">
                <qyzpxx></qyzpxx>
            </el-col>

            <el-col :span="18" class="right-box" v-if="bottomTableView">
                <byssyxx></byssyxx>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import byssyxx from "./byssyxx";
    import qyzpxx from "./qyzpxx";


    export default {
        name: "rcdj",
        components: {
            byssyxx,
            qyzpxx,
        },
        data() {
            return {
                topTableView: false,
                bottomTableView: true,
            }
        },
        created() {
            this.bottomTableView=true
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            handleSelect(key, keyPath) {
                if (key=='1'){
                    this.topTableView = true;
                    this.bottomTableView = false;
                }else if(key == '2'){
                    this.bottomTableView = true;
                    this.topTableView = false;
                }
            },
            refresh(){
                this.getList();
            },
			openNewPage(){
				this.utils.windowOpen("https://rsjjyfw.weihai.cn/zhaopin/portal");
			}
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .left-img img{
        width: 100%;
    }
    .menu-box{
        background-color: #FAFAFA;
        padding: 15px 10px;
    }
    /deep/.el-menu{
        text-align: left;
        background-color:#FAFAFA;
        border:0;
    }
    .el-menu-item{
        margin-bottom: 10px;
        background-color:#EAEAEA;
    }
    .menu-box /deep/ .el-menu-item.is-active{
        background-color:#EBEFF8;
    }
    .right-box{
        padding-left: 10px;
    }
    .search-item{
        display: flex;
        /*border-bottom: 1px solid #000000;*/
    }
    .search-item-left{
        line-height: 40px;
        font-weight: bold;
    }
    .search-item-right{
        flex: 1;
        padding: 0px 10px;
    }
    .el-button{
        border: 0px;
    }
    .el-button+.el-button{
        margin-left: 0;
    }
    .el-input-group__append button.el-button{
        background-color:#4A8DEC;
        color: #ffffff;
    }
    /deep/.el-input--medium .el-input__inner{
        height: 40px;
        line-height: 40px;
    }
    .el-input-group__append .el-button--medium{
        padding: 13px 30px;
    }
    .order-filed{
        flex: 1;
        padding: 0px 15px;
        color:#000000;
    }
    .search-table{
        margin: 0px;
        padding: 15px;
        background-color: #ffffff;
    }
    .search-item-right /deep/.el-button {
        background-color: #ffffff;
    }
</style>